import type { InputHTMLAttributes, ReactNode } from 'react';
import './checkbox.css';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'type'> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}

/** Native checkbox with a full-row label (S7 marketing opt-in, S9 "Under 18", S12 WhatsApp). */
export function Checkbox({ checked, onChange, children, className, ...rest }: CheckboxProps) {
  return (
    <label className={`check${className ? ` ${className}` : ''}`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} {...rest} />
      <span>{children}</span>
    </label>
  );
}
